/* import __COLOCATED_TEMPLATE__ from './edit-services-modal.hbs'; */
import { action, computed } from '@ember/object';
import { readOnly, sort } from '@ember/object/computed';
import { Promise } from 'rsvp';
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import LSGModalBase from '../lsg/lsg-modal-dialog-base';
import { closeModal } from 'sh-www/utils/modal-controls';

/**
 * The modal that allows users to edit the list of services.
 */
export default LSGModalBase.extend({
  /**
   * Register services
   */
  applicationCommandService : service('commands/application-commands'),
  errorTracker: service('error-tracker'),
  session: service(),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * Parameters to be passed in. Referenced by 'model.xxx'.
   */
  propertyDefaults: {
    /**
     * @param {Application}
     */
    application: null,

    /**
     * @type {Ember.MutableArray<Service>} The currently selected services.
     */
    selectedServices: () => A(),
  },

  /**
   * Private, internal state properties. Referenced by 'state.xxx'.
   */
  stateDefaults: {
    /**
     * @type {Ember.MutableArray<Service>}    All available Services loaded from the server.
     */
    availableServices: () => A(),

    /**
     * @type {Ember.MutableArray<Service>}   Array of the services that have been selected.
     */
    updatedSelectedServices: () => A(),
  },

  /** @type {Array<String>} */
  serviceSortKeys: ['category', 'name'],

  /** @type {Ember.A<Service>} */
  sortedServices: sort('state.availableServices', 'serviceSortKeys'),

  /**
   * @inheritDoc
   */
  _onInitializationComplete() {
    // TODO: show/hide spinner if loading services

    // Get the list of services for the dropdown
    this.loadServices();

    // Populate the currently selected services
    this.get('model.selectedServices').forEach((service) => {
      this.get('state.updatedSelectedServices').pushObject(service);
    });
  },

  /**
   * Load all the services from the DB.
   *
   * @return Ember.RSVP.Promise<Ember.MutableArray<Service>>
   */
  loadServices() {
    const availableServices = this.state.availableServices;
    if (availableServices.length) {
      return Promise.resolve(availableServices);
    }

    return this.store.findAll('service', {
      include: 'service-synonyms',
      adapterOptions : {
        isPublic : true
      }
    }).then(services => {
      this.set('state.availableServices', services);
      return services;
    }).catch(e => {
        this.errorTracker.error('loadServices - could not load services', this, e);
        throw e;
    });
  },

  /**
   * Whether there are currently no services selected.
   */
  _isServiceSelectionEmpty: computed('state.updatedSelectedServices.length', function() {
    return this.get('state.updatedSelectedServices.length') === 0;
  }),

  /**
   * @param {DS.Model} service
   */
    @action
  handleServiceAdded(service) {
    this.state.updatedSelectedServices.pushObject(service);
  },

  /**
   * @param {DS.Model} service
   */
    @action
  handleServiceRemoved(service) {
    this.state.updatedSelectedServices.removeObject(service);
  },

  actions: {
    onCancelClicked() {
      closeModal(this);
    },

    onUpdateClicked() {
      this.get('model.onServicesUpdated')(this.get('state.updatedSelectedServices'));
      closeModal(this);
    },
  },
});
